import { Card } from "@/components/ui/card";

const formatEur = (v) => new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(v || 0);

export function PeriodTotals({ periodTotals, periodLabel }) {
  const brouillon = periodTotals.by_status?.brouillon;
  const hasBrouillon = brouillon && brouillon.count > 0;
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4" data-testid="period-totals">
      <Card className="p-4 border border-slate-200 rounded-lg bg-white">
        <p className="text-xs text-slate-500 mb-0.5">Total HT émis</p>
        <p className="text-lg font-bold text-slate-900 money-value" data-testid="kpi-ht-emitted">{formatEur(periodTotals.emitted_ht)}</p>
        {hasBrouillon && (
          <p className="text-[11px] text-slate-500 mt-1" data-testid="kpi-ht-incl-brouillons">
            Total incl. brouillons : <span className="font-semibold text-slate-700">{formatEur(periodTotals.ht)}</span>
          </p>
        )}
        <div className="mt-2 space-y-0.5">
          {periodTotals.by_status?.payee && <p className="text-[11px] text-emerald-600">Payé : {formatEur(periodTotals.by_status.payee.ht)} ({periodTotals.by_status.payee.count})</p>}
          {periodTotals.by_status?.envoyee && <p className="text-[11px] text-orange-500">En attente : {formatEur(periodTotals.by_status.envoyee.ht)} ({periodTotals.by_status.envoyee.count})</p>}
          {hasBrouillon && <p className="text-[11px] text-slate-400">Brouillon (non inclus) : {formatEur(brouillon.ht)} ({brouillon.count})</p>}
        </div>
      </Card>
      <Card className="p-4 border border-emerald-200 rounded-lg bg-emerald-50/40">
        <p className="text-xs text-emerald-600 mb-0.5">TVA émise</p>
        <p className="text-lg font-bold text-emerald-700 money-value" data-testid="kpi-tva-emitted">{formatEur(periodTotals.emitted_tva)}</p>
        {hasBrouillon && (
          <p className="text-[11px] text-emerald-700/70 mt-1" data-testid="kpi-tva-incl-brouillons">
            Total incl. brouillons : <span className="font-semibold">{formatEur(periodTotals.tva)}</span>
          </p>
        )}
        <p className="text-[11px] text-slate-400 mt-2">{periodLabel}</p>
      </Card>
      <Card className="p-4 border border-slate-200 rounded-lg bg-white">
        <p className="text-xs text-slate-500 mb-0.5">Total TTC émis</p>
        <p className="text-lg font-bold text-slate-900 money-value" data-testid="kpi-ttc-emitted">{formatEur(periodTotals.emitted_ttc)}</p>
        {hasBrouillon && (
          <p className="text-[11px] text-slate-500 mt-1" data-testid="kpi-ttc-incl-brouillons">
            Total incl. brouillons : <span className="font-semibold text-slate-700">{formatEur(periodTotals.ttc)}</span>
          </p>
        )}
        {periodTotals.by_status?.payee && (
          <p className="text-[11px] text-emerald-600 mt-2">Encaissé TTC : {formatEur(periodTotals.by_status.payee.ttc)}</p>
        )}
      </Card>
    </div>
  );
}
